const ko = {
  ID_VOICE_CHAT_TAB_WORLD: "월드채팅",
  ID_VOICE_CHAT_TAB_PRIVATE: "1:1 채팅",

  ID_VOICE_CHAT_LIST_FOLLOWER: "팔로워",
  ID_VOICE_CHAT_LIST_FOLLOWING: "팔로잉",
  ID_VOICE_CHAT_LIST_WORLD: "월드유저",
  ID_VOICE_CHAT_LIST_SEARCH: "직접 입력",

  ID_VOICE_CHAT_PRIVATE_CHAT_REQUEST: "요청",
  ID_VOICE_CHAT_PRIVATE_CHAT_REQUEST_ING: "요청중",
  ID_VOICE_CHAT_PRIVATE_CHAT_CALLING: "진행중",

  ID_VOICE_CHAT_FOOTER_ENTER_BTN: "참여하기",
  ID_VOICE_CHAT_FOOTER_CLOSE_BTN: "종료하기",

  ID_VOICE_CHAT_WORLD_CHATTING: "월드 보이스 채팅 중입니다.",
  ID_VOICE_CHAT_FLOATING_CHATTING: "{user}님과 1:1 보이스 채팅 중입니다.",
  ID_VOICE_CHAT_FLOATING_CHATTING_APPLY:
    "{user}님에게\n1:1 보이스 채팅을 신청했습니다.",
  ID_VOICE_CHAT_FLOATING_CHATTING_ACCEPT:
    "{user}님이 1:1 보이스 채팅 요청을 수락했어요.",
  ID_VOICE_CHAT_FLOATING_CHATTING_DENY:
    "{user}님이 1:1 보이스 채팅 요청을 거절했어요.",
  ID_VOICE_CHAT_FLOATING_CHATTING_REAPPLY:
    "{user}님에게 {min}분 {sec}초 후에 다시 요청할 수 있어요.",
  ID_VOICE_CHAT_FLOATING_CHATTING_DIFFERENT:
    "{user}님은 다른 보이스 채팅을 진행 중이에요.",
  ID_VOICE_CHAT_FLOATING_CHATTING_BLOCK_ALERT:
    "{user}님에 대한 채팅 차단 해제 후 다시 시도해주세요.",
  ID_VOICE_CHAT_FLOATING_CHATTING_BLOCK: "{user}님의 모든 채팅을 차단할까요?",
  ID_VOICE_CHAT_FLOATING_CHATTING_REQUEST:
    "{user}님이 1:1 보이스 채팅을 요청하셨습니다.\n시간이 만료되면 자동으로 거절됩니다.",
  ID_VOICE_CHAT_PRIVATE_CHAT_ENTER:
    "월드 보이스 채팅을 종료하고 {user}님께 1:1 보이스 채팅을 요청할까요?",
  ID_VOICE_CHAT_WORLD_CHAT_ENTER:
    "1:1 보이스 채팅을 종료하고 월드 보이스 채팅으로 돌아갈까요?",
  ID_VOICE_CHAT_PRIVATE_CHAT_END: "1:1 보이스 채팅이 종료되었습니다.",

  ID_VOICE_CHAT_SEARCH: "검색",
  ID_VOICE_CHAT_SEARCH_PLACEHOLDER: "검색 결과가 없어요.",

  ID_VOICE_CHAT_LIST_PLACEHOLDER_WORLD:
    "월드 보이스 채팅이 진행중입니다.\n지금 보이스 채팅에 참여해보세요",

  ID_VOICE_CHAT_VERIFIED_POPUP_INFO:
    "보이스 채팅은 이메일, 휴대폰 인증을\n모두 완료해야 이용할 수 있습니다.",
  ID_VOICE_CHAT_VERIFIED_POPUP_CONFIRM: "인증하기",
};

export default ko;
